import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Usuario } from '../../../../types/Usuario.type';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getOne(id: string){
    return this.httpClient.get<Usuario>(`${this.configService.getApiUrl()}/usuario/${id}`);
  }

  getAll(){
    return this.httpClient.get<Usuario[]>(`${this.configService.getApiUrl()}/usuario`);
  }

  post(usuario: Usuario){
    return this.httpClient.post<Usuario>(`${this.configService.getApiUrl()}/usuario`, usuario);
  }

  put(usuario: Usuario){
    return this.httpClient.put<Usuario>(`${this.configService.getApiUrl()}/usuario`, usuario);
  }

  delete(id: string){
    return this.httpClient.delete<Usuario>(`${this.configService.getApiUrl()}/usuario/${id}`);
  }

  ativar(id: string){
    return this.httpClient.put<Usuario>(`${this.configService.getApiUrl()}/usuario/ativar/${id}`, null);
  }
}
